import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from '@quintoandar-tokko/jopijs';
import styles from '../filterBar.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '../FilterBar.trans.json';
import {
  formatSelectedText,
  getIsAllSelected,
  toAgentScopeItem,
} from '../utils';
import { AGENT } from '../constants/filtersConstants';
import { setSelectedIds } from '@/store/slices/components/filterBar/FilterBarSlice';
import { getCompanyAgents } from '@/store/slices/components/filterBar/service';
import SearchableMultiSelectDropdown from '@/components/shared/SearchableMultiSelectDropdown/SearchableMultiSelectDropdown';
import FilterSelectControl, {
  useFilterSelection,
} from '../FilterSelectControl';

export const MIN_AGENTS_TO_SHOW_DROPDOWN = 2;

function AgentsDropdown() {
  const dispatch = useDispatch();
  const { selectedIds, selectAgents, loadingAgents } = useSelector(
    (state) => state.FilterBarSlice.filters
  );
  const [selectedLocalIds, setSelectedLocalIds] = useState([]);

  const agentTitle = Trans(translations, 'Agents');

  useEffect(() => {
    dispatch(getCompanyAgents());
  }, [dispatch]);

  const valueTextButton = formatSelectedText(selectedIds, agentTitle, AGENT);
  const isAllSelected = getIsAllSelected(selectedIds, selectAgents, AGENT);

  const handleAgentAdd = () => {
    dispatch(setSelectedIds({ idList: selectedLocalIds, type: AGENT }));
  };

  useEffect(() => {
    const agentsSelec = selectedIds.filter((id) => id.filter_type === AGENT);
    setSelectedLocalIds(agentsSelec);
  }, [selectedIds]);

  const allAgentItems = selectAgents.map(toAgentScopeItem);

  const buttonLabel = isAllSelected
    ? Trans(translations, 'AllAgents')
    : valueTextButton;

  const selection = useFilterSelection(AGENT, {
    allLabel: Trans(translations, 'AllAgents'),
    allSelected: isAllSelected,
  });

  if (!loadingAgents && selectAgents.length < MIN_AGENTS_TO_SHOW_DROPDOWN) {
    return null;
  }

  return (
    <SearchableMultiSelectDropdown
      items={allAgentItems}
      draftSelection={selectedLocalIds}
      committedSelection={selection.items}
      onDraftChange={setSelectedLocalIds}
      onApply={handleAgentAdd}
      className={`dropdown ${styles.dropdownList}`}
      itemsClassName={styles.dropdownItems}
      multiselectClassName={styles.dropdownMultiselect}
      labels={{
        allLabel: Trans(translations, 'AllAgents'),
        applyLabel: Trans(translations, 'Apply'),
        searchPlaceholder: Trans(translations, 'SearchAgent'),
        noResultsLabel: Trans(translations, 'NoResultsFound'),
      }}
      renderTrigger={() => (
        <FilterSelectControl
          filled={selection.filled}
          pending={selectedLocalIds.length > 0}
          tooltip={selection.tooltip}
          onClear={selection.onClear}
          clearLabel={selection.clearLabel}
        >
          <Dropdown.Button
            variant="dropdownDefault"
            className={styles.dropdownButton}
            text={buttonLabel}
          />
        </FilterSelectControl>
      )}
    />
  );
}

export default AgentsDropdown;
